import 'css-chunksrc/client/scenes/projectResourceRemoval/list/task/styles.scss';export default {
  "main": "_main_1sct4_1",
  "header": "_header_1sct4_6",
  "iconBox": "_iconBox_1sct4_18",
  "icon": "_icon_1sct4_18",
  "openedIcon": "_openedIcon_1sct4_34",
  "avatar": "_avatar_1sct4_38",
  "col": "_col_1sct4_43",
  "name": "_name_1sct4_52",
  "profession": "_profession_1sct4_61",
  "selected": "_selected_1sct4_66"
};